import { render, staticRenderFns } from "./Comunicacoes.vue?vue&type=template&id=7fbca89a&"
import script from "./Comunicacoes.vue?vue&type=script&lang=js&"
export * from "./Comunicacoes.vue?vue&type=script&lang=js&"
import style0 from "./Comunicacoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports